import React from "react";

import Hoc from "../../../util/Hoc";
import CvItem from "../../../components/cvItems/CvItem";
import CvItemDesc from "../../../components/cvItems/CvItemDesc";
// import CvItemDetail from "../../../components/cvItems/CvItemDetail";

const cvSectionProDev = (props) => {
  return (
    <Hoc>
      <CvItem date="Architecture">
      <CvItemDesc descNormal="Autodesk AutoCAD 2D &amp; 3D"/>
      <CvItemDesc descNormal="Autodesk Revit"/>
      <CvItemDesc descNormal="Google SketchUp"/>
      <CvItemDesc descNormal="Autodesk 3ds Max - Mental Ray &amp; V-ray Render Engines"/>
      <CvItemDesc descNormal="Rhinoceros &amp; Grasshopper"/>
        {/* <CvItemDesc >
          <CvItemDetail> Autodesk AutoCAD 2D &amp; 3D </CvItemDetail>
          <CvItemDetail> Autodesk Revit </CvItemDetail>
          <CvItemDetail> Google SketchUp </CvItemDetail>
          <CvItemDetail> Autodesk 3ds Max - Mental Ray &amp; V-ray Render Engines </CvItemDetail>
          <CvItemDetail> Rhinoceros &amp; Grasshopper </CvItemDetail>
        </CvItemDesc> */}
      </CvItem>

      <CvItem date="Graphics & Web">
      <CvItemDesc descNormal="Adobe Master Collection (Photoshop, InDesign, Illustrator)"/>
      <CvItemDesc descNormal="HTML, CSS , JavaScript, Node.js, React.Js, React.Native"/>
      <CvItemDesc descNormal="Adobe Muse, Adobe Flash - Action Scripts"/>
        {/* <CvItemDesc>
          <CvItemDetail> Adobe Master Collection (Photoshop, InDesign, Illustrator) </CvItemDetail>
          <CvItemDetail> HTML, CSS , JavaScript, Node.js, React.Js, React.Native</CvItemDetail>
          <CvItemDetail> Adobe Muse, Adobe Flash - Action Scripts </CvItemDetail>
        </CvItemDesc> */}
      </CvItem>

      <CvItem date="Other">
      <CvItemDesc descNormal="Microsoft Project"/>
      <CvItemDesc descNormal="Microsoft Office (Word, PowerPoint &amp; Excel)"/>
        {/* <CvItemDesc>
          <CvItemDetail> Microsoft Project </CvItemDetail>
          <CvItemDetail> Microsoft Office (Word, PowerPoint &amp; Excel) </CvItemDetail>
          <CvItemDetail> Familiar with Arduino, and Digital Fabrication Sotware </CvItemDetail>
        </CvItemDesc> */}
      </CvItem>
    </Hoc>
  );
};

export default cvSectionProDev;

